module.exports = __webpack_public_path__ + "static/media/Knight439_4c.46b17eb7.svg";